module.exports = __webpack_public_path__ + "img/3x.2ffda69.jpg";